<script>
import axios from 'axios'
export default
{
    methods:
    {
        fetch()
        {
            axios.get(process.env.API_URL + '/v1/admin/middletile').then(res => {
                if (res.data)
                    this.model = res.data
            }).catch(e => {})
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

        save()
        {
            axios.post(process.env.API_URL + '/v1/admin/middletile', this.model).then(res => {
                this.model = res.data
            }).catch(e => {})
        },

    },

    data()
    {
        return {
            model: {
                is_video: false,
                video_id: null,
                url: null,
                attachments: [],
            }
        }
    },

    mounted()
    {
        this.fetch()
    }

}
</script>

<template>
    <div class="container-fluid">
        <form @submit.prevent.stop="save" ref="form">
            <div class="panel panel-primary">
                <div class="panel-heading">
                    <div class="row">
                        <div class="col-sm-12">
                            <h4>{{ $t('MENU.MIDDLETILE') }}</h4>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    <form @submit.prevent.stop="save">
                        <div class="form-group row">
                            <label class="col-md-4 control-label">
                                {{ $t('GENERAL.VIDEO')}}
                            </label>
                            <div class="col-md-6">
                                <input type="checkbox" v-model="model.is_video">
                            </div>
                        </div>

                        <div class="form-group row" v-if="model.is_video">
                            <label class="col-md-4 control-label">
                                {{ $t('GENERAL.VIDEO_ID')}}
                            </label>
                            <div class="col-md-6">
                                <input type="text" class="form-control" v-model="model.video_id">
                            </div>
                        </div>

                        <div class="row" v-if="model.is_video && model.video_id">
                            <div class="col-md-12 text-center">
                                <iframe width="480" height="273" :src="'https://www.youtube.com/embed/' + model.video_id" allowFullScreen="true">

                                </iframe>
                            </div>
                        </div>

                        <div class="form-group row" v-if="!model.is_video">
                            <label class="col-md-4 control-label">
                                {{ $t('GENERAL.LINK')}}
                            </label>
                            <div class="col-md-6">
                                <input type="text" class="form-control" v-model="model.url">
                            </div>
                        </div>

                        <div class="form-group row" v-if="!model.is_video">
                            <label class="col-md-4 control-label">
                                {{ $t('GENERAL.IMAGE') }}
                            </label>
                            <div class="col-md-8">
                                <mv-image-uploader ref="uploader" multiple @upload-done="addFile($event)" accept="image/*" :width="570" :height="300"></mv-image-uploader>

                                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                                </mv-attachment>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-md-12 text-right">
                                <button class="btn btn-success">{{ $t('GENERAL.SAVE') }}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </form>
    </div>
</template>


// WEBPACK FOOTER //
// src/pages/MiddleTile.vue